export default {
  data() {
    return {
      activeSubcaste: this.$route.query.subcaste || null,
    }
  },
  methods: {
    setActiveSubcaste(value) {
      this.activeSubcaste = value;

      // update query params
      const query = Object.assign({}, this.$route.query);

      delete query.subcaste;

      if (parseInt(value) > 0) {
        query.subcaste = value;
      }

      query.page = 1;

      if (this.$route.query !== query) {
        // to avoid duplicate navigation
        this.$router.push({ query: query });
      }
    }
  },
  watch: {
    activeSubcaste(newValue) {
      const query = Object.assign({}, this.$route.query, {
        subcaste: newValue,
      });

      if (!newValue || newValue == "-1") {
        delete query.subcaste;
      }

      const sameNumOfParams = Object.keys(this.$route.query).length === Object.keys(query).length

      if (sameNumOfParams) {
        const sameParams = Object.keys(this.$route.query).every(key => this.$route.query[key] === query[key])
        if (!sameParams) {
          this.$router.push({ query: query })
        }
      } else {
        this.$router.push({ query: query })
      }
    }
  }
}
